import { Injectable } from '@angular/core';
import { WebCommonStorageRepository } from 'webcommon/legacy-common';
import {
  AttachmentApprovalSettingsDto,
  ClientProductParametersDto,
  CustomerLicenseAssetsDto,
  ExternalMaterialSettingsDto,
  PracticeSettingsDto,
  ReportServiceConfigurationDto,
  SiteSettingsDto,
} from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class SiteSettingsService {
  constructor(private webCommonStorageRepository: WebCommonStorageRepository) { }

  private validateConfiguration(): SiteSettingsDto {
    const siteSettings = this.webCommonStorageRepository.getSiteSettings();
    if (!siteSettings) {
      throw new Error('Site settings are not available');
    }

    return siteSettings;
  }

  getClientProductParameters(): ClientProductParametersDto | undefined {
    const siteSettings = this.validateConfiguration();
    return siteSettings.ClientProductParameters;
  }

  getCustomerLicenseAssets(): CustomerLicenseAssetsDto | undefined {
    const siteSettings = this.validateConfiguration();
    return siteSettings.CustomerLicenseAssets;
  }

  getExternalMaterialSettings(): ExternalMaterialSettingsDto | undefined {
    const siteSettings = this.validateConfiguration();
    return siteSettings.ExternalMaterialSettings;
  }

  getPracticeSettings(): PracticeSettingsDto {
    const siteSettings = this.validateConfiguration();
    return siteSettings.PracticeSettings;
  }

  getCgmPortalUrl(): string | null {
    const siteSettings = this.validateConfiguration();
    return siteSettings.CgmPortalUrl;
  }

  getCgmPortalChatUrl(): string | null {
    const siteSettings = this.validateConfiguration();
    return siteSettings.CgmPortalChatUrl;
  }

  isVarCustomer(): boolean {
    const siteSettings = this.validateConfiguration();
    return siteSettings.IsVar;
  }

  getReportConfig(): ReportServiceConfigurationDto {
    const siteSettings = this.validateConfiguration();
    return siteSettings.ReportConfig;
  }

  isLegacyFeatureEnabled(featureEventName: string): boolean {
    const siteSettings = this.validateConfiguration();
    if( !siteSettings.LegacyDisabledFeatures || !siteSettings.LegacyDisabledFeatures.length) {
      return true;
    }
    return !siteSettings.LegacyDisabledFeatures.includes(featureEventName);
  }

  getAttachmentApprovalSettings(): AttachmentApprovalSettingsDto {
    const siteSettings = this.validateConfiguration();
    return siteSettings.AttachmentApprovalSettings;
  }
}
